import myCardTitle from "@/components/core/myCardTitle";
import myProgressBar from "@/components/core/myProgressBar";

export const cardMixin = {
  components: {
    myCardTitle,
    myProgressBar,
  },
  methods: {
    color(item) {
      return item.nonTraite !== 0 ? "color_danger" : "color_success";
    },
  },
};
